import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  ProductionModule,
  RawMaterialsModule,
  ProductServiceModule,
  DemoButton,
  SuppliersModule,
  MarketingModule,
  QuoteManagementModule,
  SalesOrderModule,
  DigitalCatalogModule,
} from "./CommonModules";

import CartContext from "./CartContext";
import { ECommerceB2CRetail } from "./ECommerceB2cRetail";

export class SolutionServicing extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    } else {
      const selected = prods.find(
        (p) => p.productType === ProductType.SupplyChain
      );
      SetSelectedProduct(selected);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        {/* Hero Section */}
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row gx-5">
              <div className="col-12 border-start border-5 border-primary ps-3 mb-4">
                <h6 className="text-primary text-uppercase">
                  End-to-End ERP solution Service Providers{" "}
                </h6>
                <h2 className="display-6 fw-bold">
                  Modern Solution for Service Providers (ERP)
                </h2>
                Our ERP solution for service providers streamlines every aspect
                of operations—from service booking and job sheet management to
                inventory, billing, and delivery workflows. It includes powerful
                tools for CRM, Billing, ecommerce, supplier management,
                marketing integration, and analytics. Designed for end-to-end
                automation, the system ensures improved efficiency, real-time
                insights, and seamless customer engagement.
              </div>
              <DemoButton></DemoButton>
              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "ServicingErpVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              {/* <a href="images/supplyChain/overview.png" target="_blank">
                <img
                  class="w-100 rounded"
                  src="images/supplyChain/overview.png"
                  style={{ objectFit: "contain" }}
                />
              </a> */}

              {/* <div>
                <h6 class="text-primary text-uppercase">Solution</h6>
                <h4 class="display-6  mb-0">
                  Business Workflow - Our Solution
                </h4>
                <a
                  href="images/supplyChain/supplychainworkflow.png"
                  target="_blank"
                >
                  <img
                    class="w-100 rounded"
                    src="images/supplyChain/supplychainworkflow.png"
                    style={{ objectFit: "contain" }}
                  />
                </a>
              </div> */}

              {/* <div className="col-lg-6 mb-4">
                <video
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source src="/videos/pos1.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div> */}

              <div className="col-lg-12">
                <div className="bg-light p-4 rounded shadow-sm">
                  {/* POS Feature Sections */}
                  <FeatureSection
                    title="Features & Benefits"
                    items={[
                      "Product Servicing Workflow Management",
                      "Service Booking Management",
                      "Job Cards",
                      "Purchase/Procurement Items Management",
                      "Suppliers Management",
                      "Inventory & Stocks Management",
                      "Point-Of-Sale (POS)",
                      "ECommerce B2C website",
                      "Orders Management",
                      "Packaging Management",
                      "Delivery Management",
                      "return and refund management",
                      "Customer Relationship Management (CRM)",
                      "Coupons Management",
                      "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateway Integration",
                      "HR & Payroll Management",
                      "Accounting & Balance Sheet",
                      "AI-powered solutions",
                      "Real-time dashboard with sales, billing, and inventory reports",
                      "Advanced Reporting and Analytics",
                      "Free SSL and Custom domain",
                      "Use on any device: Phone, Tablet, or PC",
                      "Customer Reviews and Feedback Management",
                      "Service History Tracking",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ERP Modules Section */}
        <section className="container my-5">
          <h5 className="text-dark mb-4">
            Explore Integrated ERP Modules That Power Your Business
          </h5>
          <Row className="g-3">
            {[
              ProductServiceModule,
              SuppliersModule,
              RawMaterialsModule,
              InventoryModule,
              PurchasesModule,
              RetailPosModule,
              ECommerceB2CModule,
              OrdersManagementModule,
              PackagingManagementModule,
              DeliveryManagementModule,
              MarketingModule,
              DigitalCatalogModule,
              LeadsManagementModule,
              QuoteManagementModule,
              SalesOrderModule,
              CrmModule,
              CouponsManagementModule,
              HrmModule,
              AccountingModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  <Module />
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

// Reusable FeatureSection component
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h5 className="fw-semibold">{title}</h5>

    <ul className="mb-0 ps-3">
      <Row>
        {items.map((item, idx) => (
          <Col xs={6} key={idx}>
            <li key={idx} className="mb-2">
              {item}
            </li>
            {/* <li key={idx}>{item}</li> */}
          </Col>
        ))}
      </Row>
    </ul>
  </div>
);
